import React from "react";

const TimeZoneSection = ({ tzData, selectedTimeZone, setOrgProfileTimeZone }) => (
  <div className="form-row mb__18">
    <label className="col-md-3" htmlFor="timeZone">
      Time Zone
    </label>
    <span className="col-md-9">
      <div className="formGroup">
        <select
          className="wth-7"
          id="timeZone"
          value={selectedTimeZone || ""}
          onChange={(e) => setOrgProfileTimeZone(e.target.value.toLowerCase())}
        >
          {tzData.map((time) => (
            <option
              key={time.id}
              value={time.mapped_time_zone.toLowerCase()}
            >
              {time.display_value}
            </option>
          ))}
        </select>
      </div>
    </span>
  </div>
);

export default TimeZoneSection;
